import Navigationbar from "../components/Navigationbar"
import { getAuth, updateEmail, updatePassword } from "firebase/auth"
import { db } from "../firebase-config"
import { getDoc, doc, updateDoc, setDoc } from "firebase/firestore"
import { useEffect, useState } from "react"
import '../Styles/Profile.css'
import '../Styles/button.css'

function Profile () {
    const auth = getAuth()
    const [currentUserData, setCurrentUserData] = useState({});
    const [newEmail, setNewEmail] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [showEmailInput, setShowEmailInput] = useState(false);
    const [showPasswordInput, setShowPasswordInput] = useState(false);

    const fetchCurrentUser = async () => {
        const userUid = auth.currentUser?.uid;
        if (userUid) {
            const userDoc = await getDoc(doc(db, 'users', userUid));
            if (userDoc.exists) {
              const userData = userDoc.data();
              setCurrentUserData(userData)
            }
          }
    } 

    const handleChangeEmail = async () => {
        try {
            await updateEmail(auth.currentUser, newEmail);
            
            
            const userRef = doc(db, 'users', auth.currentUser.uid);
            await updateDoc(userRef, {
                email: newEmail
            });
    
            alert("Email updated successfully!");
        } catch (error) {
            alert(error.message);
        }
    }
    

    const handleChangePassword = async () => {
        try {
            await updatePassword(auth.currentUser, newPassword);
                      
            alert("Password updated successfully!");
        } catch (error) {
            alert(error.message);
        }
    }

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(user => {
            if (user) {
                fetchCurrentUser();
            }
        });
    
        
        return () => unsubscribe();
    }, [currentUserData]);
    
    
    return(
<>
            <Navigationbar />
            <div className="container profile-container">
                <h1 className="main-header">Din Profil</h1>
                <div className="row">
                    <div className="">
                    <div className="userData-div">
                                <div className="userData-title">Navn:</div>
                                {currentUserData.name}
                            </div>

                            <div className="userData-div">
                                <div className="userData-title">Firma:</div>
                                {currentUserData.company}
                            </div>

                            <div className="userData-div">
                                <div className="userData-title">Email:</div>
                                {currentUserData.email}
                            </div>
                        {showEmailInput ? (
                            <>
                                <input className="profile-input" type="email" value={newEmail} onChange={e => setNewEmail(e.target.value)} placeholder="Skriv ny mail" />
                                <button className="generic-ea-btn" onClick={handleChangeEmail}>Bekræft Email</button>
                            </>
                        ) : (
                            <button className="generic-ea-btn" onClick={() => setShowEmailInput(true)}>Skift email</button>
                        )}
                        {showPasswordInput ? (
                            <>
                                <input className="profile-input" type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Skriv nye kodeord" />
                                <button className="generic-ea-btn" onClick={handleChangePassword}>Bekræft Kode</button>
                            </>
                        ) : (
                            <button className="generic-ea-btn" onClick={() => setShowPasswordInput(true)}>Skift kode</button>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}
export default Profile
